import { render, staticRenderFns } from "./mobileMenuItem.vue?vue&type=template&id=10c496a2&scoped=true"
import script from "./mobileMenuItem.vue?vue&type=script&lang=js"
export * from "./mobileMenuItem.vue?vue&type=script&lang=js"
import style0 from "./mobileMenuItem.vue?vue&type=style&index=0&id=10c496a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c496a2",
  null
  
)

export default component.exports